import { type ReactElement } from "react";
import { Navigate } from "react-router";

import { CoInvestmentFullPaths } from "@vega-modules/paths";

import { useCoInvestDealReadOnly } from "./useCoInvestDealReadOnly";

/**
 * Route guard for flows a closed or cancelled deal must not access (e.g.
 * adding prospects).
 */
export const useClosedDealRedirect = (dealId: string) => {
  const { isReadOnlyDeal, isResolved } = useCoInvestDealReadOnly();

  const redirect: ReactElement | null =
    isResolved && isReadOnlyDeal ? (
      <Navigate
        replace
        to={CoInvestmentFullPaths.CoInvestmentConfigure.replace(":id", dealId)}
      />
    ) : null;

  return { isResolving: !isResolved, redirect };
};
